var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNbnIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C11D6C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_20_Fast_Access_00000166647373059723366200000003043806374380100013_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.21,27.83c-1.53,0-3.05,0.06-4.56,0.15c-0.42-0.1-0.85-0.15-1.27-0.15H58.91c-3.22,0-5.83,2.61-5.83,5.83 s2.61,5.83,5.83,5.83h17.98C41.47,61.71,30.78,108.43,53,143.85c6.06,9.66,14.23,17.83,23.9,23.9H58.91 c-3.22,0-5.83,2.61-5.83,5.83c0,3.22,2.61,5.83,5.83,5.83h52.47c0.43,0,0.86-0.05,1.27-0.15c1.51,0.09,3.03,0.15,4.56,0.15 c41.86,0,75.79-33.93,75.79-75.79S159.07,27.83,117.21,27.83z M181.06,97.79h-23.17c-0.84-21.37-6.24-40.02-14.46-52.67 C164.55,54.61,178.93,74.73,181.06,97.79z M117.21,167.75c-13.07,0-27.52-23.67-29-58.3h58.01 C144.73,144.08,130.28,167.75,117.21,167.75z M88.21,97.79c1.48-34.63,15.94-58.3,29-58.3s27.52,23.67,29,58.3H88.21z M90.99,45.12 c-8.22,12.65-13.62,31.3-14.46,52.67H53.37C55.51,74.74,69.88,54.62,90.99,45.12z M53.37,109.45h23.17 c0.84,21.37,6.24,40.02,14.46,52.67C69.89,152.63,55.51,132.5,53.37,109.45z M143.45,162.12c8.21-12.65,13.61-31.3,14.45-52.67 h23.17C178.93,132.5,164.56,152.62,143.45,162.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.93,39.49h11.66c3.22,0,5.83-2.61,5.83-5.83s-2.61-5.83-5.83-5.83H23.93c-3.22,0-5.83,2.61-5.83,5.83 S20.71,39.49,23.93,39.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.59,167.75H23.93c-3.22,0-5.83,2.61-5.83,5.83c0,3.22,2.61,5.83,5.83,5.83h11.66 c3.22,0,5.83-2.61,5.83-5.83C41.42,170.36,38.81,167.75,35.59,167.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.65,122.8c-1.1,1.1-1.72,2.59-1.72,4.14c0.02,3.21,2.62,5.81,5.83,5.83c3.22,0,5.83-2.61,5.83-5.83 c0-1.56-0.62-3.05-1.72-4.14C31.55,120.64,27.97,120.64,25.65,122.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.87,76.16c-2.32-2.16-5.92-2.15-8.22,0.03c-2.27,2.28-2.26,5.97,0.02,8.24c1.09,1.08,2.55,1.69,4.09,1.7 c3.22,0,5.83-2.61,5.83-5.83C35.6,78.75,34.98,77.26,33.87,76.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.27,109.45h5.83c3.22,0,5.83-2.61,5.83-5.83s-2.61-5.83-5.83-5.83h-5.83c-3.22,0-5.83,2.61-5.83,5.83 S9.05,109.45,12.27,109.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.27,62.81h23.32c3.22,0,5.83-2.61,5.83-5.83s-2.61-5.83-5.83-5.83H12.27c-3.22,0-5.83,2.61-5.83,5.83 S9.05,62.81,12.27,62.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.59,144.43H12.27c-3.22,0-5.83,2.61-5.83,5.83c0,3.22,2.61,5.83,5.83,5.83h23.32 c3.22,0,5.83-2.61,5.83-5.83C41.42,147.04,38.81,144.43,35.59,144.43z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbnIcon);
export default __webpack_public_path__ + "static/media/nbn-icon.d484ddf51c3f65db3c16b90159ae2641.svg";
export { ForwardRef as ReactComponent };